import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import NProgress from 'nprogress'
import ToastService from '../_helpers/toast.service'
import JwtService from '../_helpers/jwt.service'
import utils from '../utils'
import i18n from '../i18n'
import { ROOT_API, APP_LOCALE } from '../_helpers/config'

const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = ROOT_API

    Vue.axios.interceptors.request.use(
      config => {
        NProgress.start()
        return config
      },
      error => {
        NProgress.done()
        return Promise.reject(error)
      }
    )
    Vue.axios.interceptors.response.use(
      res => {
        NProgress.done()
        const response = res.data
        return response
      },
      error => {
        NProgress.done()
        let errorMessage =
          APP_LOCALE === 'tr'
            ? 'Bir hata oluştu. Lütfen tekrar deneyiniz.'
            : 'An error occured. Please try again.'
        if (error.response) {
          const res = error.response
          const t = i18n.messages[process.env.VUE_APP_I18N_LOCALE]
          if (res.status === 400) {
            errorMessage = error.response.data.message
          } else if (res.status === 401) {
            JwtService.destroyAuthData()
            utils.redirectTo(`/${t.routes.user}/${t.routes.login}`)
            return Promise.reject(error)
          } else if (res.status === 403) {
            utils.redirectTo(`/${t.routes.error}/${t.routes.notAllowed}`)
            return Promise.reject(error)
          }
        }
        ToastService.error(errorMessage)
        return Promise.reject(error)
      }
    )
  },

  setHeader() {
    Vue.axios.defaults.headers['accept-language'] = APP_LOCALE
    const token = JwtService.getToken()
    if (token) Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`
  },

  query(resource, params) {
    this.setHeader()
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`ApiService ${error}`)
    })
  },

  get(resource, id = '') {
    this.setHeader()
    return Vue.axios.get(`${resource}/${id}`)
  },

  post(resource, params) {
    this.setHeader()
    return Vue.axios.post(`${resource}`, params)
  },

  put(resource, params) {
    this.setHeader()
    return Vue.axios.put(`${resource}`, params)
  },

  delete(resource, payload) {
    this.setHeader()
    return Vue.axios.delete(`${resource}`, payload)
  }
}

export default ApiService
